import * as React from 'react'
import TweetEmbed from 'react-tweet-embed'
import DemoImage from './demo.jpg'

import { IProject } from '../..'

const proj: IProject = {
    id: 'regexly',
    name: 'Regexly',
    type: 'app',
    tags: ['aws', 'ec2', 'mysql', 'ux', 'react', 'typescript', 'sass'],
    containsImages: true,
    containsVideos: true,
    description: (
        <>
            <p>Regex playground for JavaScript devs. Basically like a fitting room for regular expressions.</p>
            <div style={{display:'inline-block', margin: '0 5px'}}><TweetEmbed id='907338038187106304' options={{cards: 'hidden'}}/></div>
            <div style={{display:'inline-block', margin: '0 5px'}}><TweetEmbed id='907256355978756096' options={{cards: 'hidden'}}/></div>
            <img src={DemoImage} style={{width:'100%'}} alt='Regexly demo'/>
        </>
    ),
    links: new Map()
        .set('Live at regexly.chipto.io', 'https://regexly.chipto.io/')
        .set('GitHub Repository', 'https://github.com/NeekSandhu/regexly')
}

export default proj



// WEBPACK FOOTER //
// ./src/components/Projects/_projects/regexly/index.tsx